/* ============================================================================
   Livera Exclusive Offer — vanilla JS to power the Replo-exported components.
   Replaces the Replo runtime. Handles: carousels, accordion (FAQ), marquee,
   add-to-cart wiring.
   No dependencies. Drop-in.
   ============================================================================ */
(function () {
  'use strict';

  /* --------- 1) CAROUSELS  data-replo-carousel="true" --------- */
  function initCarousel(root) {
    var track = root.querySelector('[data-replo-part="slide-track"]');
    // Only this carousel's own parts — exclude parts of nested carousels
    // (the buybox main gallery contains a nested thumbnail carousel).
    function own(selector) {
      return Array.prototype.filter.call(root.querySelectorAll(selector), function (el) {
        return el.closest('[data-replo-carousel="true"]') === root;
      });
    }
    var slides = own('[data-replo-part="slide"]');
    var prevBtn = own('[data-replo-part="nav-button"][data-direction="previous"]')[0];
    var nextBtn = own('[data-replo-part="nav-button"][data-direction="next"]')[0];
    var liveRegion = root.querySelector('.replo-sr-only');
    if (!track || slides.length === 0) return;

    var idx = 0;
    var total = slides.length;

    // Replo exports two carousel layouts: sliding (slides laid out side by side)
    // and fade (slides stacked at the same offset, toggled via opacity). Detect
    // fade mode: every slide shares the same offsetLeft.
    var fadeMode = total > 1 && slides.every(function (s) { return s.offsetLeft === slides[0].offsetLeft; });

    function update() {
      if (fadeMode) {
        slides.forEach(function (s, n) {
          var active = (n === idx);
          s.style.opacity = active ? '1' : '0';
          s.style.visibility = active ? 'visible' : 'hidden';
          s.style.zIndex = active ? '1' : '0';
          s.style.pointerEvents = active ? 'auto' : 'none';
        });
      } else {
        var target = slides[idx];
        if (!target) return;
        var offset = target.offsetLeft - track.offsetLeft;
        track.style.transition = 'transform .45s ease';
        track.style.transform = 'translate3d(' + (-offset) + 'px,0,0)';
      }
      if (liveRegion) liveRegion.textContent = 'Slide ' + (idx + 1) + ' of ' + total;
      root.dispatchEvent(new CustomEvent('livera:slidechange', { detail: { index: idx } }));
    }

    function go(delta) {
      idx = (idx + delta + total) % total;
      update();
    }

    if (prevBtn) prevBtn.addEventListener('click', function (e) { e.preventDefault(); go(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function (e) { e.preventDefault(); go(1); });

    // touch / swipe — disabled for the buybox photo gallery (locked like the
    // homepage gallery: photos only change via explicit arrow clicks).
    var swipeLocked = !!(root.closest && root.closest('.r-14kpg3b'));
    if (!swipeLocked) {
      var startX = null;
      track.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      track.addEventListener('touchend', function (e) {
        if (startX == null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) go(dx > 0 ? -1 : 1);
        startX = null;
      });
    }

    // Thumbnail strip: Replo nests a second carousel inside the main one as
    // thumbnails — clicking thumb N selects slide N of this carousel.
    var nested = root.querySelector('[data-replo-carousel="true"]');
    if (nested) {
      var thumbs = Array.prototype.filter.call(nested.querySelectorAll('[data-replo-part="slide"]'), function (el) {
        return el.closest('[data-replo-carousel="true"]') === nested;
      });
      thumbs.forEach(function (th, n) {
        th.style.cursor = 'pointer';
        th.addEventListener('click', function () { idx = n % total; update(); });
      });
    }

    // re-snap on resize
    window.addEventListener('resize', update);

    // first paint
    requestAnimationFrame(update);
  }

  /* --------- 2) FAQ ACCORDION  data-replo-collapsible="true" --------- */
  function initCollapsible(root) {
    var trigger = root.querySelector('[aria-expanded]');
    if (!trigger) return;
    var panelId = trigger.getAttribute('aria-controls');
    var panel = panelId ? document.getElementById(panelId) : null;
    if (!panel) {
      // panel might be the sibling div following the trigger
      panel = trigger.nextElementSibling;
    }
    if (!panel) return;

    // Ensure starting state
    var open = trigger.getAttribute('aria-expanded') === 'true';
    panel.style.overflow = 'hidden';
    panel.style.transition = 'max-height .35s ease, opacity .25s ease';
    panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
    panel.style.opacity = open ? '1' : '0';

    function toggle() {
      open = !open;
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      root.setAttribute('data-state', open ? 'open' : 'closed');
      panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
      panel.style.opacity = open ? '1' : '0';
    }

    trigger.addEventListener('click', toggle);
    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
    });
  }

  /* --------- 3) MARQUEE  data-replo-marquee-track="true" --------- */
  /* Replo's marquee CSS already drives the animation. We just ensure it doesn't pause. */
  function initMarquee(root) {
    var track = root.querySelector('[data-replo-marquee-track="true"]');
    if (!track) return;
    // Force animation play state in case Replo runtime was pausing it
    track.style.animationPlayState = 'running';
  }

  /* --------- 3.5) CTA SCROLL → BUYBOX --------- */
  /* Replo's runtime handled CTA scroll-links; the export left them inert.
     All CTAs now smooth-scroll to the buybox (.r-14kpg3b). */
  function scrollToBuybox() {
    var bb = document.querySelector('.r-14kpg3b');
    if (bb) bb.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  function initCtaScroll(btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      scrollToBuybox();
    });
  }

  /* --------- 4) ADD TO CART --------- */
  /* Wires up [data-replo-add-product-variant-to-cart] using Shopify's /cart/add.js */
  function initAddToCart(btn) {
    btn.addEventListener('click', async function (e) {
      e.preventDefault();
      var variantId = btn.getAttribute('data-variant-id') || btn.dataset.reploVariantId;
      var qty = parseInt(btn.getAttribute('data-quantity') || '1', 10) || 1;
      if (!variantId) {
        // No variant wired yet — send the visitor to the buybox instead of dying silently.
        console.warn('[Livera] no variant id on add-to-cart button — scrolling to buybox', btn);
        scrollToBuybox();
        return;
      }

      btn.setAttribute('disabled', 'true');
      try {
        // Clear the cart first — the chosen plan must be the only line item
        // (prevents stacking plans/quantities from repeated clicks or old sessions).
        await fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } });
        var item = { id: parseInt(variantId, 10), quantity: qty };
        var sellingPlan = btn.getAttribute('data-selling-plan');
        if (sellingPlan) item.selling_plan = parseInt(sellingPlan, 10);
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [item] })
        });
        if (!res.ok) throw new Error('cart add failed: ' + res.status);
        // Redirect to checkout by default; comment out to keep on page
        window.location.href = '/checkout';
      } catch (err) {
        console.error('[Livera] add to cart error', err);
        btn.removeAttribute('disabled');
        alert('Could not add to cart. Please try again.');
      }
    });
  }

  /* --------- 5) PLAN PICKER (radio-style selection) --------- */
  /* Replo's plan cards. Wire selected state + bind to a hidden current variant. */
  function initPlanPicker(container) {
    var cards = container.querySelectorAll('[data-livera-plan]');
    if (!cards.length) return;
    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        cards.forEach(function (c) { c.removeAttribute('data-selected'); });
        card.setAttribute('data-selected', 'true');
        var variantId = card.getAttribute('data-variant-id');
        // update primary CTA
        var primaryCta = document.querySelector('[data-livera-primary-cta]');
        if (primaryCta && variantId) primaryCta.setAttribute('data-variant-id', variantId);
      });
    });
    // pre-select first card with [data-default]
    var def = container.querySelector('[data-livera-plan][data-default]') || cards[0];
    if (def) def.click();
  }

  /* --------- BOOT --------- */
  function boot() {
    document.querySelectorAll('[data-replo-carousel="true"]').forEach(initCarousel);
    document.querySelectorAll('[data-replo-collapsible="true"]').forEach(initCollapsible);
    document.querySelectorAll('[data-replo-marquee-root="true"]').forEach(initMarquee);
    document.querySelectorAll('[data-replo-add-product-variant-to-cart]').forEach(initAddToCart);
    document.querySelectorAll('[data-livera-plan-picker]').forEach(initPlanPicker);
    // CTA buttons exported as role="link" with no behavior — scroll them to the buybox.
    // Excludes carousel nav buttons and any button already wired to add-to-cart.
    document.querySelectorAll('#replo-fullpage-element button[role="link"]').forEach(initCtaScroll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
